export default __webpack_public_path__ + "assets/images/responsible-gaming-c135589bcd0ba7c6faac6948efb054b2.svg";